/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./javascript/index.ts":
/*!*****************************!*\
  !*** ./javascript/index.ts ***!
  \*****************************/
/***/ (() => {

eval("// Get Foooter link containing text 'cookie settings' and link it to the cookie pro button\nwindow.addEventListener('DOMContentLoaded', function () {\n  var footerLinks = document.querySelectorAll('.footer__inner a');\n\n  for (var _i = 0, footerLinks_1 = footerLinks; _i < footerLinks_1.length; _i++) {\n    var link = footerLinks_1[_i];\n\n    if (link.textContent.toLowerCase() == 'cookie settings') {\n      link.addEventListener('click', function (e) {\n        e.preventDefault();\n        var cookieProBtn = document.querySelector('#ot-sdk-btn-floating button');\n\n        if (cookieProBtn) {\n          cookieProBtn.click();\n        }\n      });\n    }\n  }\n});\n\n//# sourceURL=webpack://my-family-vets-theme/./javascript/index.ts?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./javascript/index.ts"]();
/******/ 	var __webpack_export_target__ = window;
/******/ 	for(var i in __webpack_exports__) __webpack_export_target__[i] = __webpack_exports__[i];
/******/ 	if(__webpack_exports__.__esModule) Object.defineProperty(__webpack_export_target__, "__esModule", { value: true });
/******/ 	
/******/ })()
;